module.exports = __webpack_public_path__ + "img/0Q3A2365_P_L_BlackMatted_MockedUp.b3b5aa6d.jpg";